var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HeaderNavContent',[(_vm.isMobile)?_c('NavButtons',[_c('li',{staticClass:"nav-button-item"},[_c('router-link',{attrs:{"to":_vm.prevRoute}},[_vm._v("Back")])],1)]):[_c('AppLogo'),_c('NavHamburger')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }